// extracted by mini-css-extract-plugin
export default {"root":"UserAchievementsCount_root__eAgU-","countText":"UserAchievementsCount_countText__9wkqJ","stats":"UserAchievementsCount_stats__odCN3"};